var Vector = /** @class */ (function () {
    function Vector(components) {
        this.components = components;
    }
    Object.defineProperty(Vector.prototype, "dimensions", {
        get: function () {
            return this.components.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Vector.prototype, "x", {
        get: function () {
            return this.components[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Vector.prototype, "y", {
        get: function () {
            return this.components[1];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Vector.prototype, "z", {
        get: function () {
            return this.components[2];
        },
        enumerable: true,
        configurable: true
    });
    Vector.prototype.abs = function () {
        var sqSum = 0;
        for (var _i = 0, _a = this.components; _i < _a.length; _i++) {
            var i = _a[_i];
            sqSum += Math.pow(i, 2);
        }
        return Math.sqrt(sqSum);
    };
    Vector.prototype.dotProduct = function (a) {
        if (this.dimensions !== a.dimensions) {
            return undefined;
        }
        var sum = 0;
        for (var i = 0; i < this.dimensions; i++) {
            sum += this.components[i] * a.components[i];
        }
        return sum;
    };
    Vector.prototype.scalarProduct = function (n) {
        return new Vector(this.components.map(function (e) { return e * n; }));
    };
    Vector.prototype.add = function (a) {
        if (this.dimensions !== a.dimensions) {
            return undefined;
        }
        var comp = [];
        for (var i = 0; i < this.dimensions; i++) {
            comp.push(this.components[i] + a.components[i]);
        }
        return new Vector(comp);
    };
    Vector.prototype.subtract = function (a) {
        if (this.dimensions !== a.dimensions) {
            return undefined;
        }
        var comp = [];
        for (var i = 0; i < this.dimensions; i++) {
            comp.push(this.components[i] - a.components[i]);
        }
        return new Vector(comp);
    };
    Vector.prototype.equals = function (a) {
        for (var i = 0; i < this.dimensions; i++) {
            if (this.components[i] !== a.components[i])
                return false;
        }
        return true;
    };
    Vector.prototype.toString = function () {
        var out = '[';
        for (var i = 0; i < this.dimensions; i++) {
            out += this.components[i] + (i + 1 === this.dimensions ? '' : ',');
        }
        out += ']';
        return out;
    };
    return Vector;
}());
export default Vector;
//# sourceMappingURL=vector.js.map